export const STATUS_SUCCESS = 'OK';
export const STATUS_INITIATED = 'INITIATED';